export interface Service {
  slug: string;
  index: string;
  title: string;
  summary: string;
  intro: string;
  scope: string[];
  image: string;
}

export interface Partner {
  slug: string;
  name: string;
  role: string;
  focus: string;
  letter: string;
  bio: string[];
  image: string;
}

export interface Article {
  slug: string;
  category: string;
  date: string;
  readTime: string;
  title: string;
  excerpt: string;
  author: string;
  image: string;
  body: string[];
  pullQuote: string;
}

export const navLinks = [
  { label: 'Expertise', to: '/expertise' },
  { label: 'People', to: '/people' },
  { label: 'Insights', to: '/insights' },
  { label: 'Contact', to: '/contact' },
];

export const heroPanels = [
  {
    a: 'https://readdy.ai/api/search-image?query=Black%20and%20white%20editorial%20portrait%20of%20a%20distinguished%20senior%20male%20accountant%20partner%20in%20his%20sixties%20with%20grey%20hair%20and%20dark%20suit%2C%20calm%20gaze%2C%20plain%20pale%20paper%20background%2C%20soft%20low%20contrast%20halftone%20print%20texture&width=600&height=1100&seq=hp-senior-m1&orientation=portrait',
    b: 'https://readdy.ai/api/search-image?query=Black%20and%20white%20close%20up%20of%20an%20old%20bound%20financial%20ledger%20with%20handwritten%20columns%20of%20figures%2C%20pale%20paper%20background%2C%20soft%20low%20contrast%20halftone%20print%20texture%2C%20archival%20editorial%20photography&width=600&height=1100&seq=hp-ledger-1&orientation=portrait',
  },
  {
    a: 'https://readdy.ai/api/search-image?query=Black%20and%20white%20stack%20of%20annual%20financial%20reports%20and%20audit%20documents%20with%20printed%20tables%20on%20a%20desk%2C%20pale%20paper%20background%2C%20restrained%20low%20contrast%20halftone%20texture%2C%20quiet%20editorial%20archive%20photography&width=600&height=1100&seq=hp-report-1&orientation=portrait',
    b: 'https://readdy.ai/api/search-image?query=Black%20and%20white%20editorial%20portrait%20of%20a%20mature%20senior%20female%20accounting%20partner%20in%20her%20fifties%20wearing%20glasses%20and%20a%20tailored%20blazer%2C%20composed%20expression%2C%20plain%20pale%20paper%20background%2C%20soft%20halftone%20print%20texture&width=600&height=1100&seq=hp-senior-w1&orientation=portrait',
  },
  {
    a: 'https://readdy.ai/api/search-image?query=Black%20and%20white%20editorial%20portrait%20of%20an%20elderly%20senior%20tax%20advisor%20with%20white%20beard%20reviewing%20a%20printed%20balance%20sheet%2C%20plain%20pale%20paper%20background%2C%20low%20contrast%20halftone%20newspaper%20print%20texture&width=600&height=1100&seq=hp-senior-m2&orientation=portrait',
    b: 'https://readdy.ai/api/search-image?query=Black%20and%20white%20rows%20of%20archive%20boxes%20and%20labelled%20financial%20document%20folders%20on%20shelves%2C%20pale%20paper%20background%2C%20soft%20low%20contrast%20halftone%20print%20texture%2C%20orderly%20editorial%20archive%20photography&width=600&height=1100&seq=hp-archive-1&orientation=portrait',
  },
];

export const heroTracks = [
  [
    'https://readdy.ai/api/search-image?query=Black%20and%20white%20editorial%20portrait%20of%20a%20distinguished%20senior%20male%20accountant%20partner%20in%20his%20sixties%20with%20grey%20hair%20and%20dark%20suit%2C%20calm%20gaze%2C%20plain%20pale%20paper%20background%2C%20soft%20low%20contrast%20halftone%20print%20texture&width=600&height=1100&seq=hp-senior-m1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Black%20and%20white%20editorial%20half%20length%20portrait%20of%20a%20senior%20female%20finance%20partner%20with%20short%20silver%20hair%20in%20a%20dark%20suit%2C%20arms%20folded%2C%20plain%20pale%20paper%20background%2C%20soft%20low%20contrast%20halftone%20print%20texture&width=600&height=800&seq=trk-l2&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Black%20and%20white%20editorial%20portrait%20of%20a%20mature%20male%20chartered%20accountant%20with%20round%20spectacles%20and%20waistcoat%20holding%20a%20fountain%20pen%2C%20plain%20pale%20paper%20background%2C%20quiet%20low%20contrast%20halftone%20texture&width=600&height=800&seq=trk-l3&orientation=portrait',
  ],
  [
    'https://readdy.ai/api/search-image?query=Black%20and%20white%20close%20up%20of%20an%20old%20bound%20financial%20ledger%20with%20handwritten%20columns%20of%20figures%2C%20pale%20paper%20background%2C%20soft%20low%20contrast%20halftone%20print%20texture%2C%20archival%20editorial%20photography&width=600&height=1100&seq=hp-ledger-1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Black%20and%20white%20typed%20balance%20sheet%20document%20with%20printed%20tables%20of%20assets%20and%20liabilities%20lying%20flat%2C%20pale%20paper%20background%2C%20restrained%20low%20contrast%20halftone%20texture%2C%20archival%20editorial%20scan&width=600&height=800&seq=trk-c2&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Black%20and%20white%20stack%20of%20annual%20financial%20reports%20and%20audit%20documents%20with%20printed%20tables%20on%20a%20desk%2C%20pale%20paper%20background%2C%20restrained%20low%20contrast%20halftone%20texture%2C%20quiet%20editorial%20archive%20photography&width=600&height=1100&seq=hp-report-1&orientation=portrait',
  ],
  [
    'https://readdy.ai/api/search-image?query=Black%20and%20white%20editorial%20portrait%20of%20a%20mature%20senior%20female%20accounting%20partner%20in%20her%20fifties%20wearing%20glasses%20and%20a%20tailored%20blazer%2C%20composed%20expression%2C%20plain%20pale%20paper%20background%2C%20soft%20halftone%20print%20texture&width=600&height=1100&seq=hp-senior-w1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Black%20and%20white%20editorial%20portrait%20of%20an%20elderly%20senior%20tax%20advisor%20with%20white%20beard%20reviewing%20a%20printed%20balance%20sheet%2C%20plain%20pale%20paper%20background%2C%20low%20contrast%20halftone%20newspaper%20print%20texture&width=600&height=1100&seq=hp-senior-m2&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Black%20and%20white%20editorial%20portrait%20of%20a%20senior%20male%20audit%20partner%20in%20his%20fifties%20with%20a%20neat%20grey%20beard%20and%20navy%20suit%20seated%20by%20a%20window%2C%20plain%20pale%20paper%20background%2C%20soft%20halftone%20texture&width=600&height=800&seq=trk-r3&orientation=portrait',
  ],
  [
    'https://readdy.ai/api/search-image?query=Black%20and%20white%20rows%20of%20archive%20boxes%20and%20labelled%20financial%20document%20folders%20on%20shelves%2C%20pale%20paper%20background%2C%20soft%20low%20contrast%20halftone%20print%20texture%2C%20orderly%20editorial%20archive%20photography&width=600&height=1100&seq=hp-archive-1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Black%20and%20white%20macro%20detail%20of%20a%20hand%20signing%20an%20audited%20financial%20statement%20with%20a%20fountain%20pen%2C%20pale%20paper%20background%2C%20soft%20low%20contrast%20halftone%20texture%2C%20quiet%20editorial%20photography&width=600&height=800&seq=trk-s2&orientation=portrait',
  ],
];

export const heroImages = {
  portraitMan: 'https://readdy.ai/api/search-image?query=Vintage%20black%20and%20white%20archival%20photograph%20of%20a%20mature%20male%20accountant%20in%20a%20wool%20suit%20and%20tie%2C%20serious%20calm%20expression%2C%20grainy%20halftone%20newspaper%20print%20texture%2C%20plain%20pale%20paper%20background&width=640&height=820&seq=avn-hero-01&orientation=portrait',
  ledger: 'https://readdy.ai/api/search-image?query=Old%20handwritten%20accounting%20ledger%20page%20with%20columns%20of%20figures%20and%20ink%20annotations%2C%20monochrome%20archival%20document%20scan%2C%20faded%20grey%20paper%20texture%2C%20soft%20even%20light%2C%20plain%20pale%20background&width=560&height=760&seq=avn-hero-02&orientation=portrait',
  portraitWoman: 'https://readdy.ai/api/search-image?query=Archival%20black%20and%20white%20portrait%20of%20a%20composed%20mature%20woman%20financial%20advisor%20in%20a%20tailored%20jacket%2C%20grainy%20printed%20magazine%20halftone%20texture%2C%20soft%20contrast%2C%20plain%20pale%20paper%20background&width=760&height=560&seq=avn-hero-03&orientation=landscape',
  typeset: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20vintage%20printed%20financial%20newspaper%20columns%20and%20typewritten%20balance%20sheet%20numbers%2C%20monochrome%20archival%20print%20with%20halftone%20dots%2C%20soft%20grey%20paper%20tone%2C%20minimal%20composition&width=820&height=520&seq=avn-hero-04&orientation=landscape',
};

export const approachImage = 'https://public.readdy.ai/ai/img_res/sandbox/9ad2232c3293228d5474f3b734806e42/4de54800-128f-4934-bf37-00c62bf50712_avenor-approach.webp';

export const perspectivePortraits: Record<string, string> = {
  'tax-planning-for-growing-businesses': 'https://public.readdy.ai/ai/img_res/sandbox/9ad2232c3293228d5474f3b734806e42/4de54800-128f-4934-bf37-00c62bf50712_avenor-persp-v01.webp',
  'evolving-role-of-financial-reporting': 'https://public.readdy.ai/ai/img_res/sandbox/9ad2232c3293228d5474f3b734806e42/4de54800-128f-4934-bf37-00c62bf50712_avenor-persp-v02.webp',
};

export const services: Service[] = [
  {
    slug: 'tax-planning',
    index: '01',
    title: 'Tax Planning & Compliance',
    summary: 'Forward-looking tax structures and accurate filings, prepared with the full picture in view.',
    intro: 'We look at tax as part of a wider set of decisions rather than an annual deadline. Planning starts early, compliance is handled carefully, and every recommendation is explained in plain language.',
    scope: ['Corporate and personal tax returns', 'Tax-efficient business structuring', 'Indirect and payroll tax review', 'Correspondence with tax authorities'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/9ad2232c3293228d5474f3b734806e42/4de54800-128f-4934-bf37-00c62bf50712_avenor-svc-01.webp',
  },
  {
    slug: 'audit-assurance',
    index: '02',
    title: 'Audit & Assurance',
    summary: 'Independent, rigorous review that gives boards, lenders and owners confidence in the numbers.',
    intro: 'Assurance only has value when it is independent and thorough. Our audit work is structured, documented and focused on what matters to the people relying on the accounts.',
    scope: ['Statutory and voluntary audits', 'Agreed-upon procedures', 'Internal control reviews', 'Grant and funding assurance'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/9ad2232c3293228d5474f3b734806e42/4de54800-128f-4934-bf37-00c62bf50712_avenor-svc-02.webp',
  },
  {
    slug: 'accounting-reporting',
    index: '03',
    title: 'Accounting & Reporting',
    summary: 'Reliable books and clear reporting, so management decisions rest on accurate information.',
    intro: 'Good reporting is less about volume and more about clarity. We maintain accurate records and shape management information around the questions your leadership actually asks.',
    scope: ['Bookkeeping and period-end close', 'Annual financial statements', 'Management accounts and KPIs', 'Outsourced finance function'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/9ad2232c3293228d5474f3b734806e42/4de54800-128f-4934-bf37-00c62bf50712_avenor-svc-03.webp',
  },
  {
    slug: 'business-advisory',
    index: '04',
    title: 'Business Advisory',
    summary: 'Measured counsel on growth, funding and structure for owners facing consequential decisions.',
    intro: 'Advisory work begins with listening. We help owners and leadership teams test their plans, understand trade-offs and move forward with a clear financial rationale.',
    scope: ['Budgeting and cash-flow forecasting', 'Funding and lender preparation', 'Performance and margin review', 'Board-level financial counsel'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/9ad2232c3293228d5474f3b734806e42/4de54800-128f-4934-bf37-00c62bf50712_avenor-svc-04.webp',
  },
  {
    slug: 'transactions-valuation',
    index: '05',
    title: 'Transactions & Valuation',
    summary: 'Diligence, valuation and deal support for acquisitions, disposals and restructurings.',
    intro: 'Transactions compress complex decisions into short timelines. We provide careful diligence and well-reasoned valuations so the people negotiating understand what they are buying or selling.',
    scope: ['Financial due diligence', 'Business and share valuation', 'Sale preparation and vendor support', 'Post-deal integration of reporting'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/9ad2232c3293228d5474f3b734806e42/4de54800-128f-4934-bf37-00c62bf50712_avenor-svc-05.webp',
  },
  {
    slug: 'private-client',
    index: '06',
    title: 'Private Client Services',
    summary: 'Discreet support for individuals and families managing wealth, succession and personal tax.',
    intro: 'Private clients need an advisor who sees the whole household, not a single return. We coordinate with your other advisors and keep personal financial matters orderly and discreet.',
    scope: ['Personal tax and residency matters', 'Succession and estate planning support', 'Family trust administration', 'Coordination with legal advisors'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/9ad2232c3293228d5474f3b734806e42/4de54800-128f-4934-bf37-00c62bf50712_avenor-svc-06.webp',
  },
];

export const partners: Partner[] = [
  {
    slug: 'eleanor-whitcombe',
    name: 'Eleanor Whitcombe',
    role: 'Managing Partner',
    focus: 'Tax Planning & Compliance',
    letter: 'W',
    bio: [
      'Eleanor leads the firm and its tax practice. Her work centres on owner-managed businesses and the structural decisions that shape them over many years.',
      'Clients value her ability to turn complex legislation into a small number of clear choices, and her insistence on documenting the reasoning behind every recommendation.',
    ],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/9ad2232c3293228d5474f3b734806e42/dcdb6831-4da0-4440-b059-7423e34fac41_avenor-partner-1.webp',
  },
  {
    slug: 'julian-ashford',
    name: 'Julian Ashford',
    role: 'Partner',
    focus: 'Audit & Assurance',
    letter: 'A',
    bio: [
      'Julian heads audit and assurance. He has spent his career reviewing the accounts of manufacturing, property and not-for-profit organisations.',
      'He believes an audit should leave a board better informed, and is known for clear, practical management letters rather than boilerplate.',
    ],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/9ad2232c3293228d5474f3b734806e42/dcdb6831-4da0-4440-b059-7423e34fac41_avenor-partner-2.webp',
  },
  {
    slug: 'margaret-lindqvist',
    name: 'Margaret Lindqvist',
    role: 'Partner',
    focus: 'Private Client Services',
    letter: 'L',
    bio: [
      'Margaret advises individuals and families on personal tax, succession and the administration of family structures.',
      'She works closely with clients\u2019 legal advisors and is trusted for her discretion, patience and careful attention to detail.',
    ],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/9ad2232c3293228d5474f3b734806e42/dcdb6831-4da0-4440-b059-7423e34fac41_avenor-partner-3.webp',
  },
  {
    slug: 'thomas-okafor-reid',
    name: 'Thomas Okafor-Reid',
    role: 'Partner',
    focus: 'Transactions & Valuation',
    letter: 'O',
    bio: [
      'Thomas leads transactions and valuation, supporting owners and investors through acquisitions, disposals and refinancing.',
      'He combines analytical rigour with a pragmatic sense of what matters in a negotiation, and stays involved well after a deal completes.',
    ],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/9ad2232c3293228d5474f3b734806e42/dcdb6831-4da0-4440-b059-7423e34fac41_avenor-partner-4.webp',
  },
];

export const articles: Article[] = [
  {
    slug: 'building-financial-resilience',
    category: 'Business Advisory',
    date: 'September 2026',
    readTime: '6 min read',
    title: 'Building financial resilience before you need it',
    excerpt: 'Resilience is rarely built during a crisis. It is the product of ordinary habits: honest forecasts, sensible buffers and decisions taken while there is still time to consider them.',
    author: 'Eleanor Whitcombe',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/9ad2232c3293228d5474f3b734806e42/4de54800-128f-4934-bf37-00c62bf50712_avenor-art-01.webp',
    pullQuote: 'The best time to understand your cash position is when nothing is wrong.',
    body: [
      'Most businesses discover how resilient they are at the least convenient moment. A large customer pays late, a lender changes terms, or costs rise faster than prices. The question is rarely whether pressure will arrive, but whether the business has the information and room to respond calmly.',
      'Resilience begins with a forecast that management genuinely believes. A rolling thirteen-week cash forecast, reviewed honestly each week, often tells leaders more than an annual budget prepared once and filed away.',
      'Buffers matter too. That may mean an agreed facility arranged in good times, a deliberate level of retained cash, or simply knowing which costs could be deferred if needed. None of these are dramatic, but together they buy time.',
      'Finally, resilience depends on decisions being made early. When owners can see a difficulty three months ahead rather than three weeks, the options are broader and the conversations with lenders, staff and suppliers are far easier.',
    ],
  },
  {
    slug: 'tax-planning-for-growing-businesses',
    category: 'Tax',
    date: 'August 2026',
    readTime: '5 min read',
    title: 'Tax planning for growing businesses',
    excerpt: 'Growth changes the tax questions a business must answer. Structures that suited a founder-led company may need revisiting as headcount, profits and ambitions expand.',
    author: 'Eleanor Whitcombe',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/9ad2232c3293228d5474f3b734806e42/4de54800-128f-4934-bf37-00c62bf50712_avenor-art-02.webp',
    pullQuote: 'Planning is most effective before a decision is made, not after the year has closed.',
    body: [
      'In the early years, tax for many businesses is largely a compliance exercise. As the business grows, however, the choices multiply: how profits are extracted, how new investment is structured, and how key people are rewarded.',
      'The most common missed opportunity is timing. Many reliefs and structuring options are only available if steps are taken before a transaction or the end of a period, so growing businesses benefit from a regular planning conversation rather than a single annual review.',
      'It is equally important to keep plans proportionate. Complexity has a cost in administration and in clarity, and the right structure is often the simplest one that meets the business\u2019s real objectives.',
      'This article is general commentary for illustration and is not tax advice. Specific circumstances always require individual review.',
    ],
  },
  {
    slug: 'evolving-role-of-financial-reporting',
    category: 'Reporting',
    date: 'July 2026',
    readTime: '7 min read',
    title: 'The evolving role of financial reporting',
    excerpt: 'Financial statements are no longer read only by auditors and tax authorities. Lenders, investors and employees increasingly expect reporting that explains as well as records.',
    author: 'Julian Ashford',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/9ad2232c3293228d5474f3b734806e42/4de54800-128f-4934-bf37-00c62bf50712_avenor-art-03.webp',
    pullQuote: 'A report that cannot be understood has not really been delivered.',
    body: [
      'For a long time, reporting was treated as an obligation: accurate, compliant and rarely read. That view is changing. Readers now want to understand not only the numbers but what drives them.',
      'This places new demands on preparers. Narrative explanations, consistent key measures and clear disclosure of judgements are becoming as important as the primary statements themselves.',
      'For smaller organisations, the lesson is practical. Well-structured management information, prepared monthly and reconciled to the year-end accounts, makes external reporting easier and decision-making better.',
      'Good reporting, in the end, is a form of communication. It should leave its readers better able to judge the health and direction of the organisation.',
    ],
  },
  {
    slug: 'succession-and-family-wealth',
    category: 'Private Client',
    date: 'June 2026',
    readTime: '6 min read',
    title: 'Succession is a conversation, not a document',
    excerpt: 'Families often focus on the paperwork of succession. The harder, more valuable work is agreeing intentions while everyone can still take part.',
    author: 'Margaret Lindqvist',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/9ad2232c3293228d5474f3b734806e42/4de54800-128f-4934-bf37-00c62bf50712_avenor-art-04.webp',
    pullQuote: 'The clearest plans are those every generation has helped to shape.',
    body: [
      'Wills, trusts and shareholder agreements are essential, but they are the final expression of decisions rather than the decisions themselves.',
      'We encourage families to begin with intentions: what should happen to a business, a property or an investment portfolio, and why. Once those intentions are clear, the technical structure usually follows naturally.',
      'Regular review is just as important. Family circumstances, legislation and asset values all change, and a plan that made sense ten years ago may now produce outcomes nobody intended.',
    ],
  },
  {
    slug: 'preparing-for-a-transaction',
    category: 'Transactions',
    date: 'May 2026',
    readTime: '5 min read',
    title: 'Preparing a business for sale, years ahead',
    excerpt: 'Owners who prepare early tend to negotiate from strength. Clean records, clear reporting and documented processes all shorten diligence.',
    author: 'Thomas Okafor-Reid',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/9ad2232c3293228d5474f3b734806e42/4de54800-128f-4934-bf37-00c62bf50712_avenor-art-05.webp',
    pullQuote: 'Diligence rewards the business that already knows its own numbers.',
    body: [
      'A sale process exposes every weakness in a company\u2019s records. Buyers and their advisors will ask detailed questions, and gaps in information typically translate into price reductions or protective clauses.',
      'Preparation two or three years ahead allows owners to address these issues calmly: normalising earnings, tidying contracts, and producing consistent monthly reporting.',
      'Early preparation also gives owners time to consider their personal objectives, from tax position to their role after completion, before negotiations begin.',
    ],
  },
  {
    slug: 'what-an-audit-should-tell-you',
    category: 'Assurance',
    date: 'April 2026',
    readTime: '4 min read',
    title: 'What an audit should actually tell you',
    excerpt: 'An audit opinion is only the headline. The observations behind it can be among the most useful information a board receives all year.',
    author: 'Julian Ashford',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/9ad2232c3293228d5474f3b734806e42/4de54800-128f-4934-bf37-00c62bf50712_avenor-art-06.webp',
    pullQuote: 'Assurance is most valuable when it leads to better decisions.',
    body: [
      'Boards often read the audit opinion and little else. Yet the process produces a detailed view of controls, judgements and risks that deserves attention.',
      'A good audit concludes with practical observations: where controls could be simpler, where estimates rely on fragile assumptions, and where reporting could be clearer.',
      'Treating those observations as an agenda for the year ahead turns a statutory obligation into a genuine management tool.',
    ],
  },
];